// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_G","galleryTitle__info":"_H","galleryTitle__infoWhite":"_I","pageLink":"_J","galleryEntryFour":"_K","galleryEntry":"_L"};